import type { CartCreationResponse } from '@/app/api/hotel-detail/cart-creation/route';
import type { BrandedFare } from '@/app/api/hotel-detail/branded-fares/route';

export const CART_CHANGE_AMOUNT = 'CART_CHANGE_AMOUNT';
export const CART_CHANGE_AMOUNT_VERSION = '1.1';

export type CartChangeAmountPayload = {
  cartId: string;
  cartQuotedPrice: number;
  cartShoppingPrice: number;
  searchId: string;
};

export type CartChangeAmountParams = {
  cartCreationResponse: CartCreationResponse;
  accommodationOnly: boolean;
  selectedBrandedFare: BrandedFare | undefined;
  selectedMealPlan: MealPlanType | undefined;
  searchId: string | undefined;
};

export const createCartChangeAmountPayload = ({
  cartCreationResponse,
  accommodationOnly,
  selectedBrandedFare,
  selectedMealPlan,
  searchId,
}: CartChangeAmountParams): CartChangeAmountPayload => ({
  cartId: cartCreationResponse.cartId || '',
  cartQuotedPrice: accommodationOnly
    ? (cartCreationResponse.cartPrice?.totalPrice ?? 0)
    : (cartCreationResponse.cartPrice?.pricePerPerson ?? 0),
  cartShoppingPrice: selectedBrandedFare?.finalPrice || selectedMealPlan?.finalPrice || 0,
  searchId: searchId || '',
});
